var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#526981",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    y: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    y: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.5fb0a054649b2ab484d42209e572a83b.svg";
export { ForwardRef as ReactComponent };